import { combineReducers } from 'redux';

const newPropertyFromScratchReducer =
  function (state = {}, action) {
    switch (action.type) {
    case 'change_address': {
      return { ...state, address: action.address };
    }
    case 'change_city': {
      return { ...state, city: action.city };
    }
    case 'change_country': {
      return { ...state, country: action.country };
    }
    case 'change_state': {
      return { ...state, state: action.state };
    }
    case 'change_zip': {
      return { ...state, zip: action.zip };
    }
    default: {
      return { zip: '', state: '', city: '', address: '', ...state };
    }
    }
  };

export default combineReducers({
  brokerSelectOptions: (state = []) => state, // readonly
  newPropertyFromScratchLocation: newPropertyFromScratchReducer
});
